/** メッセージ内の置き換え文字列定義 */
export const USER = '$USER$';

/** 各フェーズ定義 */
export const PHASE = {
  START: 'start', // 初期表示
  INPUT_DATA: 'inputData', // 入力画面
  WRITING: 'writing', // 実行中
  SUCCESS: 'success', // 成功
  INVALID_DATA: 'invalidData', // 入力エラー
  WRITE_ERROR: 'writeError', // 実行エラー
  FAILED: 'failed', // 共通エラー
};
